// Papéis na organização (espelho de backend/src/lib/permissions.ts)
export const ORG_ROLES = [
  { value: 'OWNER', label: 'Dono da organização', description: 'Tudo, inclusive cobrança e outros donos' },
  { value: 'ADMIN', label: 'Administrador', description: 'Gerencia membros, conexões e integrações' },
  { value: 'BILLING_ADMIN', label: 'Administrador de cobrança', description: 'Plano e pagamentos; o resto só leitura' },
  { value: 'MEMBER', label: 'Membro', description: 'Cria e dispara campanhas, gerencia contatos' },
  { value: 'READ_ONLY', label: 'Somente leitura', description: 'Vê tudo, não altera nada' },
] as const;

export const orgRoleLabel = (role?: string | null) => ORG_ROLES.find((r) => r.value === role)?.label ?? role ?? '';
